import { Box, Typography, styled } from "@mui/material";
import { tokens } from "@/tokens";

export const DropzoneContainer = styled(Box)({
  border: `2px dashed ${tokens.border.default}`,
  borderRadius: tokens.radius.lg,
  padding: "40px 32px",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  backgroundColor: tokens.bg.hover,
  "&:hover": {
    borderColor: tokens.brand.primary,
    backgroundColor: `${tokens.brand.primary}08`,
  },
  "&.active": {
    borderColor: tokens.brand.primary,
    backgroundColor: `${tokens.brand.primary}08`,
  },
});

export const IconContainer = styled(Box)({
  marginBottom: "12px",
  display: "flex",
  justifyContent: "center",
});

export const DropzoneSmallText = styled(Typography)({
  color: tokens.text.muted,
  fontSize: tokens.fontSize.base,
});
